import request from "@utils/request";

export function getAnnouncements(params) {
  return request.get("/getAnnountcementList", params, { login: true });
}

export function getAnnouncement(data) {
  return request.post("/getAnnouncement", data, { login: true });
}
